export default {
    Metadata: {
        Name: "EndsWith",
        Description: "Returns whether or not a string ends with a given character sequence.",
        Syntax: "EndsWith(search_string, end_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(searchStr, endString) {   //Stress Test, may be off by one...EK
        if (searchStr == undefined || endString == undefined) {
            return false;
        }
        if (typeof searchStr != 'string') {
            searchStr = searchStr.toString();
        }

        return searchStr.endsWith(endString);
        //var foundIndex = searchStr.indexOf(endString);
        //return (foundIndex == searchStr.length - endString.length);
    },
};

